<template>
  <DialogTemplate data-gwmenu="noclose">
    <div
      class="py-2 px-2"
      style="max-width: 620px"
    >
      <div class="text-large weight_700 clr-primary">
        {{ $t('gameformat.bet_sizes') }}
      </div>
      <div class="help-grid-cont mt-4">
        <div
          v-for="item in options"
          :key="item.title"
        >
          <div class="item_title f-align-center mb-1 weight_600">
            {{ item.title }}
          </div>
          <div class="item_explanation clr-grey text-medium item_explanation_open no-events">
            <div v-html="item.text"></div>
          </div>
        </div>
      </div>
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'StudyBetSizesHelpDialog',
  components: {
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  methods: {
    close() {
      this.$store.dispatch('router_reset_dialogs')
    },
  },
  computed: {
    options() {
      // let legacyKeys = {}
      // if (!this.$store.getters.showLegacySolutions) {
      // const { gameformats } = this.$store.getters
      // console.log(gameformats)
      // gameformats.filter(g => g.legacy).forEach(g => {
      // legacyKeys[g.type] = true
      // })
      // }
      let res = [
        { id: 'simplified' },
        { id: 'simple' },
        { id: 'general' },
        { id: 'complex', hide: !this.$store.getters.showLegacySolutions },
        { id: 'research' },
        { id: 'advanced' },
        { id: 'basic', hide: !this.$store.getters.showLegacySolutions },
      ]
      res = res.map(i => {
        const r = {
          ...i,
          // hide: legacyKeys[i.id],
          title: this.$t(`tooltips.gmf_types.${i.id}`),
          text: this.$t(`tooltips.gmf_types.${i.id}_text`),
        }
        return r
      })
      res = res.filter(i => !i.hide)
      return res
    },
  },
}
</script>

<style lang="scss" scoped>
.help-grid-cont {
  display: grid;
  grid-gap: 1rem;
}
.item {
  &_title {
    border-radius: 4px;
    display: flex;
    align-content: center;
    transition: 0.2s;
  }
  &_explanation {
    max-height: 0;
    will-change: max-height;
    overflow: hidden;
    &_open {
      transition: max-height 0.3s ease-in-out;
      max-height: 999px;
    }
  }
}
.blocker-icon {
  font-size: 1.5rem;
  line-height: 1;
}
</style>
